import http from '../http';
import type {
  DailyStatus, DropReviewList, DropReviewSaveItem, DropReviewSaveResult, MorningSummary, ReviewState,
} from '../types/daily';
import {
  normalizeDailyStatus, normalizeDropReviewSave, normalizeDropReviews, normalizeMorningSummary,
} from '../utils/daily';
import { markPriceSummaryStale } from '../utils/priceSummary';

// 아침 서버 체인 · 오늘 상태 · 서버 검토 API(감사 card-controltower#566, 백엔드 PR #78 · #79) — api.ts 와 따로 둔다(열린 PR 과 겹치지 않게).
// 모양이 다른 응답은 null 로, 404(옛 서버) · 오류는 그대로 던진다 — 부른 쪽이 예전 방식으로 돌아간다.

export const fetchDailyStatus = (date?: string): Promise<DailyStatus | null> =>
  http.get<unknown>('/api/cards/daily-status', { params: date ? { date } : undefined }).then((r) => normalizeDailyStatus(r.data));

/** ① 아침 체인을 이 매장만 지금 — 진행 중이면 409. */
export const startMorningChain = (): Promise<{ chainId: string | null }> =>
  http.post<{ chainId?: string }>('/api/cards/morning-chain').then((r) => ({ chainId: r.data?.chainId ?? null }));

export const fetchMorningSummary = (date?: string): Promise<MorningSummary | null> =>
  http.get<unknown>('/api/cards/morning-summary', { params: date ? { date } : undefined }).then((r) => normalizeMorningSummary(r.data));

export const fetchDropReviews = (state?: ReviewState): Promise<DropReviewList | null> =>
  http.get<unknown>('/api/cards/drop-reviews', { params: state ? { state } : undefined }).then((r) => normalizeDropReviews(r.data));

export const saveDropReviews = (items: DropReviewSaveItem[]): Promise<DropReviewSaveResult> =>
  http.put<unknown>('/api/cards/drop-reviews', { items }).then((r) => normalizeDropReviewSave(r.data))
    // 서버가 칩 건수 요약 캐시를 비운다(감사 #745, 백엔드 PR #93) — 화면도 다시 받게 알린다.
    .finally(markPriceSummaryStale);
